import script from "./BlogNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogNavigation.vue?vue&type=script&setup=true&lang=js"

import "./BlogNavigation.vue?vue&type=style&index=0&id=4138f4ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4138f4ee"]])

export default __exports__